import { START_TIMER, STOP_TIMER } from '../constants'
import { createAction, handleActions } from 'redux-actions'

// ACTION CREATORS
export const startTimer = createAction(START_TIMER)
export const stopTimer = createAction(STOP_TIMER)

// REDUCERS
export default handleActions(
  {
    START_TIMER: (state, action) => (
      true
    ),
    STOP_TIMER: (state, action) => (
      false
    )
  },
  false
)



// WEBPACK FOOTER //
// ./src/ducks/timer.ts